/* File: global.jsx
 * Path: ananunadm/src/helpers/global.jsx
*/
import { useContext, createContext } from "react";

export const Global = createContext();

export function useGlobal() {
	return useContext(Global);
}
